import React from 'react';
import { Alert, Button, Tooltip, Card, Col, Form, Icon, Input, InputNumber, message, Modal, Popover, Row, Switch, Radio, Checkbox, DatePicker } from 'antd';
import { fetchEvt } from "../../redux/actions/evt";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Iconfont from "../../components/Iconfont/Iconfont";
import { disableEventTicketing, enableEventTicketing, patchEventTicketings, patchEventConfig } from "../../services/evt";
import { getFeeRate, isVasValidity, isValidity } from "../../services/global";
import { findUserDefault } from "../../services/user";
import Decimal from "decimal.js/decimal";
import NumberFormat from 'react-number-format';
import lodash from "lodash"
import MoneyInput from "../../components/MoneyInput";
import EvtViewTicketingFormDiscount from "./EvtViewTicketingFormDiscount";
import moment from 'moment';
import PurchaseServiceTips from "../PurchaseServiceTips";
import CkInfoItem from "../../components/CkInfoItem";
import evtConfigDes from './EvtConfigDes'


const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return { cmEnums };
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});

const { TextArea } = Input;
class EvtViewTicketForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formLoading: false,
            enableAttendeeInvoice: props.evt.config.enableAttendeeInvoice,
            memberNumPeo: 500,
            cashWithdrawRate: null,
            ticketEditableDiscount: false,
            ticket: null,
        }
    }

    componentDidMount() {
        this.mounted = true;
        getFeeRate().then(res => {
            if (res.code == 200) {
                this.setState({
                    cashWithdrawRate: res.data["CASH_WITHDRAW_RATE"]
                })
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })



        isValidity('SENIORMEMBER', (vaild) => {
            this.setState({
                validityMember: vaild
            })
        })
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    resetFormFields = () => {
        this.props.form.resetFields();
    }

    enableTicketing = (ticketingId, eventId) => {
        enableEventTicketing({ id: ticketingId, eventId: eventId }).then(res => {
            if (res.code == 200) {
                message.info("打开成功!");
                this.props.editableChange(this.props.editableStatePropName, false, true)
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })
    }

    disableTicketing = (ticketingId, eventId) => {
        disableEventTicketing({ id: ticketingId, eventId: eventId }).then(res => {
            if (res.code == 200) {
                message.info("关闭成功!");
                this.props.editableChange(this.props.editableStatePropName, false, true)
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })
    }

    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {

                    this.changeFormLoading(true);
                    const that = this;

                    values.__self__.forEach((obj, index) => {
                        if (!this.state.validityMember) {
                            obj.enableSoldTime = false;
                        }
                        if (obj.enableSoldTime) {
                            obj.soldStartTime = moment(obj.soldStartTime).format("YYYY-MM-DD HH:mm");
                            obj.soldEndTime = moment(obj.soldEndTime).format("YYYY-MM-DD HH:mm");
                        }

                    })

                    //去除_开头的属性(为了动态字段添加的)
                    var _values = {...values};
                    Object.keys(_values).forEach((key) => {
                        if (key != "__self__" && key.startsWith("_")) {
                            delete _values[key]
                        }
                    })
                    patchEventConfig(Object.assign({id: this.props.evt.header.id}, {enableAttendeeInvoice: this.state.enableAttendeeInvoice})).then(res => {
                        if (res.code == 200) {

                        } else {
                            message.error(res.msg, 6);
                        }
                    }).catch(err => {
                        message.warn("访问异常");
                    })

                    patchEventTicketings(Object.assign({eventId: this.props.evt.header.id}, values)).then(res => {
                        if (res.code == 200) {
                            message.info("更新成功!");
                            that.props.editableChange(this.props.editableStatePropName, false, true)
                        } else {
                            message.error(res.msg, 6);
                        }
                    }).catch(err => {
                        message.warn("访问异常");
                    }).finally(() => {
                        that.changeFormLoading(false)
                    })

            } else {
                console.log('error', error, values);
            }
        });
    }

    changeFormLoading = (loading) => {
        if (this.mounted) {
            this.setState({
                formLoading: loading
            })
        }
    }

    addField = (fieldName, value = {}) => {
        const { form } = this.props;
        var fieldsValue = form.getFieldsValue();
        var _fieldVal = lodash.get(fieldsValue, `_${fieldName}`);
        _fieldVal.push(value);

        lodash.set(fieldsValue, `_${fieldName}`, _fieldVal);


        form.setFieldsValue(fieldsValue);
        this.setState({
            needReloadUniqueSelect: true,
        })
    }


    removeField = (fieldName, index) => {
        const { form } = this.props;
        var fieldsValue = form.getFieldsValue();
        let fieldVal = lodash.get(fieldsValue, fieldName);
        let _fieldVal = lodash.get(fieldsValue, `_${fieldName}`);
        fieldVal.splice(index, 1);
        _fieldVal.splice(index, 1);

        lodash.set(fieldsValue, `_${fieldName}`, _fieldVal);
        lodash.set(fieldsValue, fieldName, fieldVal);

        form.setFieldsValue(fieldsValue);

        this.setState({
            needReloadUniqueSelect: true,
        })
    }

    handleCancel = () => {
        this.changeFormLoading(false)
        this.props.editableChange(this.props.editableStatePropName, false)
    }
    showOrHideModal = (status) => {
        this.setState({ ticketEditableDiscount: status })
    }
    updateField = (fieldName, value) => {
        const { form } = this.props;
        var fieldsValue = form.getFieldsValue();
        lodash.set(fieldsValue, `_${fieldName}`, value);
        // lodash.set(fieldsValue, `${fieldName}`, value);

        form.setFieldsValue(fieldsValue);

    }
    render() {
        const evt = this.props.evt;

        const { getFieldDecorator, getFieldValue, getFieldError } = this.props.form;
        getFieldDecorator('___self__', { initialValue: evt.ticketings.map(t => t) });
        const ticketings = getFieldValue('___self__') ? getFieldValue('___self__') : [];


        const ticketComp =
            <Row gutter={18} className="form-item-ticket-comp">
                {ticketings.map((c, index) => {
                    return (
                        <Col span={24} key={`ticketings${index}`}>
                            <Card bodyStyle={{ padding: "12px 12px 12px 0" }}>
                                <div className="form-item-ticket-contain">
                                    <div className="form-item-ticket-micon-contain">
                                        <Iconfont libname="ckicon" type="piao2" />
                                    </div>
                                    <div className="form-item-ticket-content-contain">
                                        <div style={{ display: "none" }}>
                                            {getFieldDecorator(`__self__[${index}].id`, {
                                                initialValue: c.id,
                                                rules: [{ required: false }],
                                            })(
                                                <Input />
                                            )}
                                        </div>
                                        <Form.Item hasFeedback help="">
                                            {getFieldDecorator(`__self__[${index}].name`, {
                                                initialValue: c.name,
                                                rules: [{ required: true, whitespace: true }, { whitespace: true, message: '不能输入空格!' }, { min: 1, max: 100, message: '长度限制为1至20个之间!' }],
                                            })(
                                                <TextArea placeholder="售票名" autosize={{ minRows: 1, maxRows: 1 }} />
                                            )}
                                        </Form.Item>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 13  }}>
                                            <span>
                                                {getFieldDecorator(`__self__[${index}].approveAttendee`, {
                                                    initialValue: c.approveAttendee,
                                                })(
                                                    <Radio.Group>
                                                        {Object.values(this.props.cmEnums.data.TicketingApproveStatusEnum).map((item, index) => {
                                                            return <Radio style={{display:index == 2 ? 'none' : 'inline-block'}} value={item.enumName.toString()} key={index}>{item.enumDesc}</Radio>
                                                        })}
                                                    </Radio.Group>
                                                )}
                                            </span>
                                            <span>
                                                {getFieldDecorator(`__self__[${index}].enableSoldTime`, {
                                                    initialValue: c.enableSoldTime,
                                                    valuePropName: 'checked',
                                                    rules: [{ required: false }],
                                                })(
                                                    <Checkbox onChange={e => {
                                                        this.state.validityMember ?
                                                            this.updateField(`__self__[${index}].enableSoldTime`, e.target.checked)
                                                            :
                                                            this.pstView.show()
                                                    }} >时间范围</Checkbox>
                                                )}
                                            </span>

                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 10,height:26 }}>
                                            <span>
                                                {getFieldDecorator(`__self__[${index}].maxPurchase`, {
                                                    initialValue: c.maxPurchase,
                                                    rules: [{ type: "number", required: true }],
                                                })(
                                                    <InputNumber
                                                        style={{ width: 136 }}
                                                        min={0}
                                                        max={30000}
                                                        step={1}
                                                        precision={0}
                                                        placeholder="每人限购张数"
                                                        formatter={value => {
                                                            return `${value}张/人`;
                                                        }}
                                                        parser={value => {
                                                            return value.replace('张', '').replace('/', '').replace('人', '')
                                                        }}
                                                    />
                                                )}
                                            </span>

                                            <div>
                                                {
                                                    c.enableSoldTime &&
                                                    <span>
                                                        <Form.Item hasFeedback help="" style={{ display: 'inline-block', marginRight: 8 }}>
                                                            {getFieldDecorator(`__self__[${index}].soldStartTime`, {
                                                                initialValue: c.soldStartTime ? moment(c.soldStartTime) : null,
                                                                rules: [{ required: true, }],
                                                            })(
                                                                <DatePicker
                                                                    showTime={{ defaultValue: moment('00:00:00', 'HH:mm') }}
                                                                    format="YYYY-MM-DD HH:mm"
                                                                    placeholder="开始范围"
                                                                    style={{ width: 150 }} />
                                                            )}
                                                        </Form.Item>
                                                        <Form.Item hasFeedback help="" style={{ display: 'inline-block', }}>
                                                            {getFieldDecorator(`__self__[${index}].soldEndTime`, {
                                                                initialValue: c.soldEndTime ? moment(c.soldEndTime) : null,
                                                                rules: [{ required: true, }],
                                                            })(
                                                                <DatePicker
                                                                    showTime={{ defaultValue: moment('00:00:00', 'HH:mm') }}
                                                                    format="YYYY-MM-DD HH:mm"
                                                                    placeholder="结束范围"
                                                                    style={{ width: 150 }} />
                                                            )}
                                                        </Form.Item>
                                                    </span>}
                                            </div>

                                        </div>


                                    </div>
                                    <div className="form-item-ticket-money-contain">
                                        <Form.Item hasFeedback help="">
                                            {getFieldDecorator(`__self__[${index}].price`, {
                                                initialValue: c.price,
                                                rules: [{ required: true }],
                                            })(
                                                <MoneyInput
                                                    prefix={<Iconfont style={{ fontSize: 18 }} libname="ckicon" type="Money" />}
                                                    placeholder="售价"
                                                />
                                            )}
                                        </Form.Item>
                                        <Form.Item hasFeedback help="">
                                            <Input.Group compact>
                                                {getFieldDecorator(`__self__[${index}].quantity`, {
                                                    initialValue: c.quantity,
                                                    rules: [{ type: "number", required: true }],
                                                })(
                                                    <InputNumber
                                                        min={0}
                                                        //max={this.state.memberNumPeo}
                                                        max={30000}
                                                        step={100}
                                                        precision={0}
                                                        placeholder="可售票数"
                                                        formatter={value => {
                                                            return `${value}张`;
                                                        }}
                                                        parser={value => {
                                                            return value.replace('张', '')
                                                        }}
                                                    />
                                                )}
                                            </Input.Group>
                                        </Form.Item>
                                    </div>
                                    {ticketings.length > 1 &&
                                        <a href="#" className="card-ck-contain-remove"
                                            onClick={() => this.removeField("__self__", index)}>
                                            <div><Icon type="delete" />删除</div>
                                        </a>
                                    }
                                </div>


                            </Card>
                        </Col>
                    )
                })}
                <Col span={3}>
                    <Card bodyStyle={{ padding: "12px" }} style={{ border: "none" }}>
                        <a className="card-ck-contain-add" onClick={() => this.addField("__self__", { quantity: 0, price: 0, maxPurchase: 0 })}> <Icon type="plus" /> </a>
                    </Card>
                </Col>
            </Row>

        return (
            <Form>
                <Row gutter={18} className="ticket-comp">
                    {evt.ticketings.map((ticket, index) => {
                        return (
                            <Col span={24} key={`ticket${index}`}>
                                <Card bodyStyle={{ padding: "5px" }}>
                                    <div className={`ticket-contain ${ticket.active ? "" : "disable"}`}>
                                        <div className="ticket-micon-contain">
                                            <Iconfont libname="ckicon" type="piao2" />
                                        </div>
                                        <div className="ticket-content-contain">

                                            <div>
                                                <div className="ticket-content-name">


                                                    {ticket.name}
                                                </div>
                                                <div className="ticket-content-quantity">
                                                    <div className="quantity-des">
                                                        <span>
                                                            {evt.config.eventMode == 'BYREGISTER' ?
                                                                '限购1张'
                                                                :
                                                                (ticket.maxPurchase == 0 ? '不限购' : `限购${ticket.maxPurchase}张`)
                                                            }
                                                        </span>
                                                        <span className="mdc-text-grey">
                                                            {
                                                                ticket.quantity > 0 ? `总${ticket.quantity}张` : "不限数量"
                                                            }
                                                        </span>
                                                        <span className="mdc-text-red">售{ticket.sold}张</span>
                                                        {
                                                            ticket.quantity > 0 ? <span className="mdc-text-green">余{ticket.quantity - ticket.sold >= 0 ? ticket.quantity - ticket.sold : 0}张</span> : null
                                                        }

                                                    </div>

                                                </div>
                                            </div>

                                            {/*<div className="ticket-income">
                                                    <span>收入：￥{ticket.sold * ticket.price}</span>
                                                </div>*/}
                                        </div>
                                        <div className="ticket-money-contain">
                                            <div>
                                                <div>单价￥{ticket.price}</div>
                                                <div>

                                                    <Popover
                                                        overlayClassName={ticket.active ? "ticketing-enable" : "ticketing-disable"}
                                                        placement="left"
                                                        content={
                                                            <a style={{ fontSize: 14 }} onClick={(e) => {
                                                                ticket.active ? this.disableTicketing(ticket.id, evt.header.id) :
                                                                    this.enableTicketing(ticket.id, evt.header.id)
                                                            }}>
                                                                <Icon type={ticket.active ? "pause-circle-o" : "play-circle-o"} />
                                                                {
                                                                    ticket.active ? " 暂停" : " 开启"
                                                                }
                                                            </a>
                                                        }
                                                        trigger="click">
                                                        <div className="ticket-tool-btn">
                                                            {
                                                                ticket.active ? "售票中" : "已暂停"
                                                            }
                                                        </div>
                                                    </Popover>
                                                    {evt.config.eventMode == 'BYPURCHASE' ?
                                                        <a className='ticket-discount-btn' onClick={() => {
                                                            this.setState({
                                                                ticket: ticket
                                                            })
                                                            this.showOrHideModal(true)
                                                        }}>批发价</a> :
                                                        <Tooltip overlayClassName='overlay-image' mouseEnterDelay={0.3} title={
                                                            <span>
                                                                <p>批发价可以设置一次性购买多张票时优惠，如：原价10元/张，18元/2张，21元/3张等</p>
                                                                <p>该活动目前是报名模式（参与人仅能购票1张，无法设置批发价），如需使用，请在「报名」参数切换成购票模式</p>
                                                                <p>如需直减优惠码，请看：<a target={'_blank'} href={'https://www.kancloud.cn/seven_qdj/qdj_detail01/1822294'}>直减优惠码</a></p>
                                                            </span>
                                                        }>
                                                            <a className='ticket-discount-btn' style={{ color: '#959595' }}>批发价</a>
                                                        </Tooltip>
                                                    }



                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            </Col>
                        )
                    }
                    )}
                </Row>

                <Modal
                    visible={this.props.editable}
                    title="编辑票种"
                    width="880px"
                    afterClose={() => this.resetFormFields()}
                    maskClosable={false}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>
                            放弃
                        </Button>,
                        <Button key="submit" type="primary" loading={this.state.formLoading} onClick={this.save}>
                            保存
                        </Button>,
                    ]}
                >
                    {
                        this.state.cashWithdrawRate ?
                            <Alert
                                message={
                                    <div>
                                        <p>根据国家法律要求，2022年1月1日起，签到家不再支持代收业务，仅提供定制渠道支付方式</p>
                                        <p>定制直接支付到贵公司账户，定制费用5000元起，联系：18615776026</p>
                                        <p></p>
                                        <p>票名，如：早鸟票</p>
                                        <p>票价，设置票单价，0是免费</p>
                                        <p>票数，售票总数，可控制报名数量，0张无限多</p>
                                        <p>限制，单人最多可购买N张/人，0张/人不限制（报名模式固定1张/人）</p>
                                        <p>请详细阅读<a href="http://static.checkinmaster.com/Xlzg_Pay_Policy.html" target="_Blank"> 支付协议</a>，违反国家相关法规您将承担一切责任</p>
                                    </div>
                                }
                                type="info"
                            />
                            : null
                    }
                    <CkInfoItem label={
                        <div>
                            {evtConfigDes.enableAttendeeInvoice.name}
                            <Tooltip placement="bottom" overlayClassName='overlay-image'
                                mouseEnterDelay={0.3} title={
                                    <div style={{ overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: evtConfigDes.enableAttendeeInvoice.help }}></div>
                                }>
                                <span title="" style={{ marginLeft: "3px" }}><Icon
                                    type="question-circle-o" /></span>
                            </Tooltip>
                        </div>
                    }>
                        <Switch checked={this.state.enableAttendeeInvoice}
                            onChange={e => this.setState({ enableAttendeeInvoice: e })}
                            checkedChildren={evtConfigDes.enableAttendeeInvoice.switch[0]}
                            unCheckedChildren={evtConfigDes.enableAttendeeInvoice.switch[1]} />
                    </CkInfoItem>
                    {ticketComp}
                </Modal>
                <EvtViewTicketingFormDiscount
                    show={this.showOrHideModal}
                    evt={this.props.evt}
                    ticket={this.state.ticket}
                    editable={this.state.ticketEditableDiscount}
                    editableStatePropName={"ticketEditable"}
                    editableChange={this.props.editableChange} />

                <PurchaseServiceTips
                    ref={(pst) => {
                        this.pstView = pst
                    }}
                    member={'SENIORMEMBER'}

                />
            </Form>
        )
    }
}


EvtViewTicketForm.contextTypes = {}

EvtViewTicketForm.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "ticketEditable",
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewTicketForm.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewTicketForm));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewTicketingForm.jsx